import { useEffect, useState } from "react";
import axios from "axios";
import "./ApprovedApplications.css";
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import { resubmitMails } from "../../../services/complitedProfilesService";

const ResubmitApplications = () => {
  const [approved, setApproved] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.userId;
  let districtId = localStorage.getItem("districtId");
  districtId = districtId && districtId !== "null" ? Number(districtId) : null;


  let zoneId = localStorage.getItem("zoneId");
  zoneId = zoneId && zoneId != "null" ? Number(zoneId) : null;
  useEffect(() => {
    const fetchSubmitted = async () => {
      setLoading(true);
      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/resubmit`);
        const response = await resubmitMails(districtId,zoneId);
        // Extract array safely
        const data = Array.isArray(response.data) ? response.data : [];

        // ✅ Sort by updatedDate descending (latest first)
        const sorted = data.sort((a, b) => {
          const t1 = new Date(a.personalInformation?.updatedDate || 0);
          const t2 = new Date(b.personalInformation?.updatedDate || 0);
          return t2 - t1; // descending order
        });

        setApproved(sorted);
      } catch (err) {
        console.error("Failed to load approved applications", err);
        setApproved([]);
      } finally {
        setLoading(false);
      }
    };
    fetchSubmitted();
  }, []);

  const handleClick = (app) => {
    const applicationId = app.personalInformation?.employeeUniqueId;
    if (!applicationId) {
      alert("Application ID is missing.");
      return;
    }
    navigate("/esicForm", { state: { application: app, applicationId } });
  };

  return (
    <div>
      {loading ? (
        <div className="loading">Loading...</div>
      ) : approved.length === 0 ? (
        <div className="empty-state">No approved applications found.</div>
      ) : (
        <div className="approved-table">
          <div className="approved-header">
            <div className="approved-col">Full Name</div>
            <div className="table-col">District</div>
            <div className="approved-col">Job Position</div>
            <div className="approved-col">Contact Number</div>
            <div className="approved-col">Submission Date and Time</div>
            <div className="approved-col">Updated By</div>
            <div className="approved-col">Status</div>
          </div>

          {approved.map((app, index) => {
            const formattedDateTime = app.timestamp
              ? format(new Date(app.timestamp), "dd-MM-yyyy, hh:mm a")
              : "—";

            return (
              <div key={index} className="approved-row">
                <div className="approved-col">{app.fullname || "N/A"}</div>
                <div className="table-col">{app.district || "N/A"}</div>

                <div className="approved-col">{app.jobposition || "N/A"}</div>
                <div className="approved-col">{app.contactNumber || "N/A"}</div>


                <div className="approved-col">{formattedDateTime}</div>

                <div className="approved-col">{app.filledByName || "N/A"}</div>

                <div className="approved-col">
                  {app.status
                    ? app.status.charAt(0).toUpperCase() +
                    app.status.slice(1).toLowerCase()
                    : "N/A"}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>

  );
};

export default ResubmitApplications;